import { SearchInput } from "components/SearchInput/SearchInput";
import { Button } from "components/Button/Button";

import styles from "../styles.module.scss";

type SearchBarProps = {
  onSearch: (product: string) => void;
};

export const SearchBar = ({ onSearch }: SearchBarProps): JSX.Element => {
  return (
    <div className={styles.searchBar}>
      <SearchInput callback={onSearch} />
      <Button icon="qrScanner" />
    </div>
  );
};
